import get from 'lodash/get'

import { stopsLabel } from '../../../common/constants/constants'

function getAirlineName(airlines) {
  if (airlines.length === 1) {
    return airlines[0].name
  }
  return ''
}

/** = Functionality */
/** @TODO: see if this can be set at listings Data Composer level */
function getAirlinesForThisSlice(segmentList, airlines) {
  const segmentAirlineSet = segmentList.reduce(
    (acc, listItem) => acc.add(listItem.marketingAirline),
    new Set()
  )

  return Array.from(segmentAirlineSet).reduce((acc, airline) => {
    const foundAirline = airlines?.find((item) => item.code === airline)
    if (foundAirline) {
      acc.push(foundAirline)
    }
    return acc
  }, [])
}

export default function buildReadableItinDescription(itinerary, tripType, sliceSelection = false) {
  const singleSliceText = []
  const srText = itinerary.slices.map((slice, index) => {
    const airlines = getAirlinesForThisSlice(get(slice, 'segments', []), itinerary.marketingAirlines)
    const airlineName = getAirlineName(airlines)
    const departingAirportCode = slice?.departInfo?.airport?.code
    const arrivalAirportCode = slice?.arrivalInfo?.airport?.code
    const departTime = slice?.departInfo?.time?.displayTime
    const arrivalTime = slice?.arrivalInfo?.time?.displayTime
    let layoverDurations = []
    let layoverLocations = []
    if (slice.layoverInfo && slice.layoverInfo.length > 0) {
      slice.layoverInfo.forEach((layover) => {
        layoverDurations.push(layover?.duration)
        layoverLocations.push(layover?.airport?.code)
      })
    }
    let stopsText = ''
    let sliceType = ''
    switch (slice.stops) {
      case 0:
        stopsText = stopsLabel.nonStop
        break
      case 1:
        stopsText = stopsLabel.oneStop
        break
      default:
        stopsText = `${slice.stops} ${stopsLabel.stops}`
    }

    if (tripType === 'RT') {
      sliceType = index === 0 ? 'Depart' : 'Return'
    }

    const itinDetailsText =
      `${stopsText} ${sliceType} flight by ${airlineName}.` +
      `Departing from ${departingAirportCode} at ${departTime}.` +
      `Arriving at ${arrivalAirportCode} at ${arrivalTime}.`
    const layoverText = slice.stops > 0 ? `${layoverDurations} layover at ${layoverLocations}.` : ''

    if (sliceSelection) {
      singleSliceText.push(`${itinDetailsText} ${layoverText}`)
    }
    return itinDetailsText + layoverText
  })

  return sliceSelection ? singleSliceText : srText
}

export function buildNumOfItinsReturnedText(totalItins, listings, isDeparture) {
  let srText = isDeparture ? 'Choose your departure flight.' : 'Choose your return flight.'

  // Filtering out all non-retail itineraries
  let numOfListings = listings.filter(
    (itinerary) => !itinerary.ad && !itinerary.nyop && !itinerary.crossSellAd && !itinerary.isExpressDeal
  ).length

  const doesIncludeEXD = listings.some((itinerary) => itinerary.isExpressDeal)

  if (totalItins === 1 && numOfListings === 1 && !doesIncludeEXD) {
    srText = `Showing 1 out of 1 result. ${srText}`
  } else if (totalItins > 0) {
    // If EXD present, add 1 to listings length and totalFilteredItineraries to compensate
    // for additional EXD card renders
    srText = `Showing 1 to ${numOfListings + (doesIncludeEXD ? 1 : 0)} out of ${
      totalItins + (doesIncludeEXD ? 1 : 0)
    } results. ${srText}`
  }

  return srText
}
